import React from "react"
import { Analytics } from "@vercel/analytics/react"
import "./App.css"

import CateringPage from "./components/CateringPage"

function App() {
  return (
    <div className="App">
      <CateringPage />
      <Analytics />
    </div>
  )
}

export default App
